var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.buttonClass,attrs:{"href":_vm.buttonURL,"role":"button","aria-pressed":"true"}},[_vm._v(_vm._s(_vm.sizeText))])}
var staticRenderFns = []

export { render, staticRenderFns }